import { EmergencySituationInstructions } from '../realtime';

export type EmergencyInstructionItem = {
  instructions: EmergencySituationInstructions;
  buttonTextKey: string;
  smsTextKey: string;
};

export const INSTRUCTION_ITEMS: EmergencyInstructionItem[] = [
  {
    instructions: EmergencySituationInstructions.Cpr,
    buttonTextKey: 'Chat_SendCprInstructions_ButtonTitle',
    smsTextKey: 'Chat_CprEmergencySituationInstructions_SmsText',
  },
  {
    instructions: EmergencySituationInstructions.Choking,
    buttonTextKey: 'Chat_SendChokingInstructions_ButtonTitle',
    smsTextKey: 'Chat_ChokingEmergencySituationInstructions_SmsText',
  },
  {
    instructions: EmergencySituationInstructions.ChildChoking,
    buttonTextKey: 'Chat_SendChildChokingtructions_ButtonTitle',
    smsTextKey: 'Chat_ChildChokingEmergencySituationInstructions_SmsText',
  },
  {
    instructions: EmergencySituationInstructions.GpsInstructionsIos,
    buttonTextKey: 'Chat_SendLocationInstructionsIos_ButtonTitle',
    smsTextKey: 'Chat_GpsInstructionsIos_SmsText',
  },
  {
    instructions: EmergencySituationInstructions.GpsInstructionsAndroid,
    buttonTextKey: 'Chat_SendLocationInstructionsAndroid_ButtonTitle',
    smsTextKey: 'Chat_GpsInstructionsAndroid_SmsText',
  },
  {
    instructions: EmergencySituationInstructions.CameraInstructionsIos,
    buttonTextKey: 'Chat_SendCameraInstructionsIos_ButtonTile',
    smsTextKey: 'Chat_CameraInstructionsIos_SmsText',
  },
  {
    instructions: EmergencySituationInstructions.CameraInstructionsAndroid,
    buttonTextKey: 'Chat_SendCameraInstructionsAndroid_ButtonTile',
    smsTextKey: 'Chat_CameraInstructionsAndroid_SmsText',
  },
];
